// import 'es6-promise/auto'
import 'babel-polyfill'

import Vue from 'vue'

import axios from 'axios/dist/axios'
Vue.prototype.$ajax = axios

// import lodash from 'lodash'
// Vue.use(lodash)
// Object.defineProperty(Vue.prototype, '$lodash', { value: lodash })
// use internally

import AOS from 'aos'
import 'aos/dist/aos.css'

import ElementUI from 'element-ui'
import en from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI, { locale: en })

// Carousel
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import App from './App.vue'
import store from './controllers/store'
import router from '@/router'
import '@/router/hook'

import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: -150,
  cancelable: true,
  onDone: false,
  onCancel: false
})

import Scrollspy from '@/controllers/ScrollSpy'
Vue.use(Scrollspy)

// // GA
// import VueAnalytics from 'vue-analytics'
// Vue.use(VueAnalytics, {
//   id: 'UA-112311200-14',
//   router
// })

// GTag
import VueGtag from 'vue-gtag'
Vue.use(VueGtag, {
  config: { id: 'G-ML5V300DSM' }
}, router)

import VueYouTubeEmbed from 'vue-youtube-embed'
Vue.use(VueYouTubeEmbed)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store,
  mounted () {
    AOS.init({ duration: 800 })
  },
}).$mount('#app')
